export default __webpack_public_path__ + "ubisoftsans-regular.woff2";